<template>
  <nav>
    <v-toolbar
      class="toolbar"
      color="teal darken-1"
      app
      flat
    >
      <v-toolbar-side-icon
        class="hidden-lg-and-up"
        @click="isOpened = !isOpened"
      />

      <router-link
        class="toolbar__title-link hidden-sm-and-down"
        to="/"
      >
        <v-toolbar-title class="toolbar__title subheading text-uppercase white--text">
          <span>JAM</span>
          <span class="font-weight-light">-App</span>
        </v-toolbar-title>
      </router-link>

      <v-spacer />

      <v-layout
        row
        class="mr-4 ml-4"
      >
        <v-text-field
          v-model="searchInput"
          clear-icon="clear"
          clearable
          flat
          single-line
          color="white"
          label="Suche nach Film, Serie, Person"
          prepend-inner-icon="search"
          @keyup.esc="searchInput = ''"
          @click:clear="searchInput = ''"
        />
      </v-layout>


      <v-toolbar-items class="hidden-md-and-down">
        <v-btn
          v-for="(link, index) in links"
          :key="index"
          :to="link.route"
          class="caption"
          flat
          color="white"
        >
          <v-icon
            small
            left
            color="white"
          >
            {{ link.icon }}
          </v-icon>
          {{ link.title }}
        </v-btn>

        <v-btn
          v-if="checklogin"
          to="/favoriten"
          class="caption"
          flat
          color="white"
        >
          <v-icon
            small
            left
            color="white"
          >
            bookmarks
          </v-icon>Favoriten &nbsp;
          <span v-if="getFavLength !== 0">({{ getFavLength }})</span>
        </v-btn>

        <v-btn
          class="caption"
          flat
          color="white"
          @click="openParamModal"
        >
          <v-icon
            small
            left
            color="white"
          >
            tune
          </v-icon>Suche filtern
        </v-btn>

        <v-tooltip
          v-if="checklogin"
          bottom
        >
          <v-btn
            slot="activator"
            class="mb-0 mt-1"
            fab
            dark
            flat
            color="white"
            @click="openConfirmModal"
          >
            <v-icon color="white">
              exit_to_app
            </v-icon>
          </v-btn>
          <span>Abmelden</span>
        </v-tooltip>

        <v-tooltip
          v-else
          bottom
        >
          <v-btn
            slot="activator"
            class="mb-0 mt-1"
            fab
            dark
            flat
            color="white"
            @click="openUserModal"
          >
            <v-icon color="white">
              person
            </v-icon>
          </v-btn>
          <span>Anmelden / Registrieren</span>
        </v-tooltip>
      </v-toolbar-items>
      <!-- <template
        v-if="!isHomePage"
        v-slot:extension
      /> -->
    </v-toolbar>


    <v-navigation-drawer
      v-model="isOpened"
      width="260"
      class="drawer"
      app
      temporary
    >
      <div class="headline subheading white--text pa-2 teal">
        <span>JAM</span>
        <span class="font-weight-light ml-2">-App</span>
      </div>

      <v-img
        :aspect-ratio="16/8"
        :src="bannerSrc"
      >
        <v-layout
          v-if="checklogin"
          pa-2
          column
          fill-height
          class="lightbox white--text"
        >
          <v-spacer />
          <v-flex shrink>
            <div class="drawer__profile body-2 font-weight-light">
              Dein Profil:
              <span class="body-1">{{ checklogin }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-img>

      <v-list>
        <v-list-tile
          router
          to="/"
        >
          <v-list-tile-action>
            <v-icon color="white">
              home
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              Startseite
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="(link, index) in links"
          :key="index"
          router
          :to="link.route"
        >
          <v-list-tile-action>
            <v-icon color="white">
              {{ link.icon }}
            </v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              {{ link.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="checklogin"
          to="/favoriten"
        >
          <v-list-tile-action>
            <v-icon color="white">
              bookmarks
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              Favoriten &nbsp;
              <span v-if="getFavLength !== 0">({{ getFavLength }})</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="openParamModal">
          <v-list-tile-action>
            <v-icon color="white">
              tune
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              Suche filtern
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider />

        <v-list-tile
          v-if="checklogin"
          @click="openConfirmModal"
        >
          <v-list-tile-action>
            <v-icon color="white">
              exit_to_app
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              Abmelden
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-else
          @click="openUserModal"
        >
          <v-list-tile-action>
            <v-icon color="white">
              person
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="body-1">
              Anmelden / Registrieren
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>


<script>
const bannerSrc = require('../assets/banner.jpg');

export default {
  data() {
    return {
      isOpened: false,
      searchInput: '',
      lastTimeout: null,
      debounceInterval: 1000,
      bannerSrc,
      drawerWidth: 300,
      links: [
        { title: 'Filme', icon: 'movie', route: '/filme' },
        { title: 'Serien', icon: 'tv', route: '/serien' },
        { title: 'Personen', icon: 'person', route: '/personen' },
      ],
    };
  },
  computed: {
    checklogin() {
      return this.$store.getters.login;
    },
    getFavLength() {
      return this.$store.getters.getFavLength;
    },
    isHomePage() {
      return this.$route.name === 'home';
    },
  },
  watch: {
    searchInput() {
      if (!this.searchInput) {
        this.$store.commit('setLoading', false);
        // if (this.$route.name !== 'search') {
        //   this.$store.commit('resetQueryResults');
        // }
        return;
      }
      if (this.$route.name !== 'search' && this.searchInput !== '') {
        this.$store.commit('resetQueryResults');
        this.$router.push('/suche');
      }

      if (this.searchInput !== '') {
        this.debounce();
      }
    },
    $route() {
      if (this.$route.name !== 'search') {
        this.searchInput = '';
      }
    },
    drawerWidth() {
      if (window.innerWidth <= 500) {
        this.drawerWidth = 250;
      }
    },
  },
  methods: {
    openUserModal() {
      this.$store.commit('openUserModal');
      this.isOpened = false;
    },
    openConfirmModal() {
      this.$store.commit('openConfirmModal');
    },
    openParamModal() {
      this.$store.commit('openParamModal');
      this.isOpened = false;
    },
    makeRequest() {
      this.$store.commit('resetQueryResults');
      this.$store.dispatch('getQueryResults', { query: this.searchInput });
    },
    debounce() {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
      }
      this.lastTimeout = setTimeout(this.makeRequest, this.debounceInterval);
    },
    clearInput() {
      this.searchInput = '';
    },

  },
};
</script>

<style lang="scss">
.toolbar {
  &__title-link {
    text-decoration: none;
  }
  .v-btn--active {
    color: #fff !important;
  }
}
.drawer {
  &__profile {
    position: absolute;
    bottom: 0;
    background: rgb(0, 0, 0);
    background: rgba(0, 0, 0, 0.8);
    color: #f1f1f1;
    width: 100%;
    padding: 10px;
  }
}
</style>
